var React = require('react');

function Web (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 6v5h40V6H1Z","stroke":"#D22128","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M1.5 39.5V13.883h39V39.5h-39Z","stroke":"#D22128","key":1}),React.createElement("path",{"d":"M21 35c4.97 0 9-3.806 9-8.5S25.97 18 21 18s-9 3.806-9 8.5 4.03 8.5 9 8.5Z","stroke":"#D22128","strokeMiterlimit":"10","key":2}),React.createElement("path",{"d":"M27 21c-1.547 1.23-3.656 2-6 2s-4.453-.77-6-2M15 33c1.56-1.255 3.685-2 6-2s4.44.745 6 2","stroke":"#D22128","strokeMiterlimit":"10","key":3}),React.createElement("path",{"d":"M20.5 35c2.485 0 4.5-3.806 4.5-8.5S22.985 18 20.5 18 16 21.806 16 26.5s2.015 8.5 4.5 8.5ZM30 27H12M21 18v17","stroke":"#D22128","strokeMiterlimit":"10","key":4})]);
}

Web.defaultProps = {"width":"42","height":"40","fill":"none"};

module.exports = Web;

Web.default = Web;
